import { useEffect } from 'react';

import type React from 'react';

function useOutsideClick(
  dropDownRef: React.RefObject<HTMLElement | null>,
  inputRef: React.RefObject<HTMLElement | null>,
  fn: () => void,
) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Node | null;

      if (
        dropDownRef?.current &&
        target &&
        !dropDownRef?.current.contains(target) &&
        inputRef.current &&
        !inputRef.current.contains(target)
      ) {
        fn();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropDownRef, fn, inputRef]);
}

export default useOutsideClick;
